<template>
  <div>
    <div v-if="isSendResume == 0">
      <div class="apply-window" v-show="isShow">
        <div class="apply-wrap">
          <div class="apply-title">
            <span class="apply-tit">申请职位</span
            ><img
              src="@/assets/img/close.png"
              class="close-icon"
              @click="closeApply"
              alt=""
            />
          </div>
          <ul class="apply-list">
            <li class="apply-item">
              <span class="apply-layble">姓名</span>
              <div class="apply-input-wrap">
                <input
                  type="text"
                  placeholder="请输入你的姓名"
                  class="apply-input"
                  v-model="userInfo.name"
                  @blur="nameBlur(userInfo.name)"
                  v-if="!isToken"
                />
                <div class="apply-data" v-else>{{ userInfo.name }}</div>
              </div>
            </li>
            <li class="notice" v-show="hasName">
              <img
                src="@/assets/img/notice.png"
                class="notice-icon"
                alt=""
              />请填写姓名
            </li>
            <li class="apply-item">
              <span class="apply-layble">手机号</span>
              <div class="apply-input-wrap" v-if="!isToken">
                <input
                  type="text"
                  maxlength="11"
                  placeholder="请输入你的手机号"
                  class="apply-input"
                  v-model="userInfo.phone"
                  @blur="phoneVerify(userInfo.phone)"
                  @input="phoneSize(userInfo.phone)"
                />
                <div
                  class="get-code-null"
                  :class="{ getcode: isPhone }"
                  @click="getCode"
                  v-if="canClick"
                >
                  {{ codeText }}
                </div>
                <div class="get-code-null" v-else>{{ codeText }}</div>
              </div>
              <div class="apply-input-wrap apply-data" v-else>
                {{ userInfo.phone }}
              </div>
            </li>
            <li class="notice" v-show="hasPhone">
              <img
                src="@/assets/img/notice.png"
                class="notice-icon"
                alt=""
              />请填写手机号
            </li>
            <li class="apply-item" v-if="!isToken">
              <span class="apply-layble">验证码</span>
              <div class="apply-input-wrap">
                <input
                  type="text"
                  placeholder="输入验证码"
                  maxlength="4"
                  v-model="userInfo.code"
                  class="apply-input"
                  @blur="codeVerify(userInfo.code)"
                />
              </div>
            </li>
            <li class="notice" v-show="hasCode">
              <img
                src="@/assets/img/notice.png"
                class="notice-icon"
                alt=""
              />请输入正确的验证码
            </li>
            <li class="apply-item">
              <span class="apply-layble">上传简历</span>
              <!-- 登录后的简历窗口 -->
              <div class="apply-input-wrap apply-file-box" v-if="isToken">
                <div class="apply-file">
                  <div
                    class="apply-file-wrap"
                    v-show="userInfo.resumeFileName != ''"
                  >
                    <img src="@/assets/img/file.png" class="file_icon" alt="" />
                    <div>{{ userInfo.resumeFileName }}</div>
                  </div>
                </div>
                <div class="add-file-wrap">
                  重新上传
                  <input
                    type="file"
                    ref="clearFile"
                    @change="reUploadFile($event)"
                    accept=".doc, .docx, .pdf, .wps"
                    class="add-file-btn"
                  />
                </div>
              </div>
              <!-- 登录后的简历窗口 -->
              <!-- 未登录的简历窗口 -->
              <div class="apply-input-wrap apply-file-box" v-else>
                <div class="apply-file">
                  <div
                    class="apply-file-wrap"
                    v-show="userInfo.resumeFileName != ''"
                  >
                    <img src="@/assets/img/file.png" class="file_icon" alt="" />
                    <div>{{ userInfo.resumeFileName }}</div>
                    <img
                      src="@/assets/img/remove_file.png"
                      class="remove_file"
                      @click="removeFile"
                      alt=""
                    />
                  </div>
                </div>
                <div class="add-file-wrap">
                  选择文件
                  <input
                    type="file"
                    ref="clearFile"
                    @change="uploadFile($event)"
                    accept=".doc, .docx, .pdf, .wps"
                    class="add-file-btn"
                  />
                </div>
              </div>
              <!-- 未登录的简历窗口 -->
            </li>
            <li class="notice" v-show="hasFile">
              <div class="" v-show="hasFile">
                <img
                  src="@/assets/img/notice.png"
                  class="notice-icon"
                  alt=""
                />请选择文件
              </div>
            </li>
            <li class="notice-tip">
              支持word、pdf、ppt、wps格式文件，文件大小需小于10M
            </li>
          </ul>
          <div class="apply-btn-wrap">
            <div class="apply-btn-confirm" @click="pushFile" v-if="isToken">
              修改
            </div>
            <div
              class="apply-btn-push"
              @click="applyResume(clientId, jobId)"
              v-if="!isLoading"
            >
              立即投递
            </div>
            <div class="apply-btn-push" v-else><a-spin size="small" /></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 投递窗口 -->
  </div>
</template>
<script>
import {
  userLogin,
  SendResume,
  ReUploadResume,
  GetUserInfo,
} from "@/api/user.js";
import axios from "axios";

export default {
  name: "Apply",
  props: ["isSendResume", "isShow", "clientId", "jobId"],
  inject: ["reload"],
  data() {
    return {
      isPhone: false,
      canClick: true,
      hasName: false,
      hasPhone: false,
      hasCode: false,
      hasFile: false,
      hasGetCode: false,
      isLoading: false,
      fileList: [],
      userInfo: {
        name: "",
        phone: "",
        code: "",
        resumeFileName: "",
        resumeUrl: "",
      },
      isToken: false,
      codeText: "获取验证码",
      timer: null,
      isShowSon: true,
      isChange: false,
      isLogout: false,
      isTimeLong: true,
      message:'test'
    };
  },
  created() {
    if (localStorage.userInfo) {
      this.userInfo = JSON.parse(localStorage.userInfo);
      this.isToken = true;
      this.isPhone = true;
    } else {
      this.isToken = false;
      this.userInfo = {
        name: "",
        phone: "",
        code: "",
        resumeFileName: "",
        resumeUrl: "",
      };
    }
  },
  methods: {
    // 更新简历缓存
    getUser() {
      GetUserInfo()
        .then((res) => {
          if (res.success) {
            if (localStorage.userInfo) {
              if (this.userInfo.resumeFileName != res.data.resumeFileName) {
                this.userInfo.resumeFileName = res.data.resumeFileName;
                this.userInfo.name = res.data.name;
                this.userInfo.resumeUrl = "resumeUrl";
                localStorage.userInfo = JSON.stringify(this.userInfo);
              }
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 上传简历
    uploadFile(event) {
      if (event.target.files[0]) {
        this.userInfo.resumeFileName = event.target.files[0].name;
        this.hasFile = false;
        this.fileList.push(event.target.files[0]);
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]); // 解析成base64格式
        let that = this.userInfo;
        let isChange = this.isChange;
        let mainthis = this;
        reader.onload = function () {
          that.resumeUrl = this.result;
          if (isChange) {
            let data = {
              resumeFileName: that.resumeFileName,
              resumeUrl: that.resumeUrl,
            };
            ReUploadResume(data)
              .then((res) => {
                if (res.success) {
                  isChange = false;
                  mainthis.$message.success("更换简历成功");
                  mainthis.userInfo.resumeUrl = "resumeUrl";
                  localStorage.userInfo = JSON.stringify(mainthis.userInfo);
                } else {
                  mainthis.$message.success("更换简历失败");
                }
              })
              .catch((rej) => {
                console.log(rej);
              });
          }
        };
      } else {
        return;
      }
    },
    removeFile() {
      this.userInfo.resumeFileName = "";
    },
    // 重新上传简历
    reUploadFile(event) {
      this.isChange = true;
      this.uploadFile(event);
    },
    // 注销账号
    pushFile() {
      this.isToken = false;
      this.isLogout = true;
      this.userInfo.name = "";
      this.userInfo.phone = "";
      this.userInfo.code = "";
      this.userInfo.resumeFileName = "";
      this.userInfo.resumeUrl = "";
      this.isPhone = false;
    },
    // 关闭窗口
    closeApply() {
      if (this.isLogout) {
        // this.reload();
        this.userInfo = JSON.parse(localStorage.userInfo);
        this.isToken = true;
        this.isPhone = true;
        this.isLogout = false;
      }
      this.$emit("closeWin", [false]);
    },
    // 验证手机号格式
    phoneSize(phone) {
      if (phone.length == 11) {
        this.phoneVerify(phone);
      }
    },
    phoneVerify(phone) {
      if (/^1\d{10}$/.test(phone)) {
        this.hasPhone = false;
        this.isPhone = true;
      } else {
        this.isPhone = false;
        this.hasPhone = true;
      }
    },
    // 验证姓名
    nameBlur(e) {
      if (e != "") {
        this.hasName = false;
      }
    },
    // 获取验证码
    getCode() {
      if (!this.isPhone) {
        this.hasPhone = true;
        return;
      }
      let data = new FormData();
      data.append("phone", this.userInfo.phone);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post("Api/Login/GetPhoneCode", data, config)
        .then((res) => {
          if (res.data.success) {
            clearInterval(this.timer);
            var time = 59;
            this.canClick = false;
            this.codeText = time + "s后重发";
            this.timer = setInterval(() => {
              if (time <= 0) {
                this.codeText = "获取验证码";
                this.canClick = true;
              } else {
                time--;
                this.canClick = false;
                this.codeText = time + "s后重发";
              }
            }, 1000);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    codeVerify(code) {
      if (code == "") {
        this.hasCode = true;
      } else {
        this.hasCode = false;
      }
    },
    // 投递简历按钮
    applyResume(clientId, jobId) {
      let sendData = {
        jobId: jobId,
        clientId: clientId,
      };
      if (this.userInfo.name == "") {
        this.hasName = true;
      }
      if (this.userInfo.phone == "") {
        this.hasPhone = true;
      }
      if (this.userInfo.resumeFileName == "") {
        this.hasFile = true;
      }
      if (this.userInfo.code == "") {
        this.hasCode = true;
      }
      if (!this.isPhone) {
        this.$message.error("请填写正确的手机号");
      }
      if (
        this.userInfo.name != "" &&
        this.userInfo.phone != "" &&
        this.isPhone &&
        this.userInfo.resumeFileName != "" &&
        this.userInfo.code != ""
      ) {
        // 投递简历
        if (this.isToken) {
          SendResume(sendData)
            .then((res) => {
              if (res.success) {
                this.$emit("closeWin", [true]);
                this.$message.success("投递成功");
                this.$emit("isSend", "isSend");
                this.isToken = true;
              } else {
                if (res.status == 403) {
                  this.$emit("closeWin", [true]);
                  this.$message.success("已投递！");
                  this.$emit("isSend", "isSend");
                  this.isToken = true;
                  // this.reload();
                }
              }
            })
            .catch((rej) => {
              console.log(rej);
            });
        } else {
          let userInfo = this.userInfo;
          this.isLoading = true;
          userLogin(this.userInfo)
            .then((res) => {
              this.isLoading = false;
              this.isTimeLong = false;
              if (res.success) {
                let nowTime = new Date().getTime();
                let expires = nowTime + res.data.expires_in * 1000;
                this.userInfo.resumeUrl = "resumeUrl";
                localStorage.userInfo = JSON.stringify(userInfo);
                localStorage.expires = JSON.stringify(expires);
                localStorage.token = JSON.stringify(res.data.access_token);
                SendResume(sendData)
                  .then((res) => {
                    if (res.success) {
                      this.$emit("closeWin", [true]);
                      this.$message.success("投递成功");
                      this.$emit("isSend", "isSend");
                      this.isToken = true;
                      // this.reload();
                    } else {
                      if (res.status == 403) {
                        this.$emit("closeWin", [true]);
                        this.$message.success("已投递！");
                        this.$emit("isSend", "isSend");
                        this.isToken = true;
                        // this.reload();
                      }
                    }
                  })
                  .catch((rej) => {
                    console.log(rej);
                  });
              } else {
                if (res.status == 0) {
                  this.hasCode = true;
                  return;
                }
              }
            })
            .catch((rej) => {
              console.log("rejrejrejrej", rej);
              this.$message.error("网络原因请求超时，请重试！");
              this.isLoading = false;
              return false;
            });
        }
      }
    },
  },
  watch: {
    isShow: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getUser();
        }
      },
    },
  },
};
</script>
<style scoped>
.job-push {
  width: 160px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3b87ff;
  border-radius: 3px;
  color: #fff;
  font-size: 16px;
}
.job-icon {
  width: 16px;
  height: 16px;
  margin-right: 13px;
}
.apply-window {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 22;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}
.apply-wrap {
  width: 500px;
  /* height: 390px; */
  background: #ffffff;
}
.apply-title {
  height: 50px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-icon {
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.apply-list {
  padding: 20px;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.apply-item {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.apply-layble {
  width: 80px;
}
.apply-input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  height: 38px;
  border-radius: 2px;
  border: 1px solid #dddddd;
}
.apply-input {
  flex: 1;
  padding: 0 14px;
}
.get-code-null {
  height: 100%;
  line-height: 38px;
  padding-right: 15px;
}
.getcode {
  color: #3b87ff;
  cursor: pointer;
}
.apply-input-wrap >>> .el-button--primary {
  background-color: #3b87ff;
  border-color: #3b87ff;
  height: 37px;
  width: 88px;
  transform: translateX(2px);
  border-radius: 1px;
}
.notice {
  color: #ff8800;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding-left: 80px;
  margin: -7px 0 7px;
}
.notice-icon {
  width: 14px;
  height: 14px;
  margin-right: 3px;
}
.notice-tip {
  color: #999999;
  font-size: 12px;
  padding-left: 80px;
}
.apply-btn-wrap {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
}
.apply-btn-confirm,
.apply-btn-push {
  width: 90px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #dddddd;
  cursor: pointer;
}
.apply-btn-push {
  background: #3b87ff;
  border-color: #3b87ff;
  color: #fff;
  margin-left: 10px;
}
.apply-file {
  flex: 1;
  padding: 0 14px;
}
.apply-file-wrap {
  display: flex;
  align-items: center;
}
.apply-file-wrap > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;
}
.file_icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.remove_file {
  width: 14px;
  height: 14px;
  margin-left: 8px;
}
.add-file-wrap {
  position: relative;
  width: 89px;
  height: 101%;
  transform: translateX(1px);
  background: #3b87ff;
  color: #fff;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
}
.add-file-btn {
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}
.noclick {
  background: #adcdff;
}
.apply-data {
  padding-left: 14px;
}
.apply-btn-push >>> .ant-spin-dot-item {
  background-color: #fff;
}
</style>
